import React from 'react';
import { motion } from 'framer-motion';

/**
 * BlurFade — fade + blur + lift entry animation.
 *
 * Note: animates on mount (not via useInView) so it plays reliably even
 * when Lenis smooth-scroll is intercepting scroll events. The component
 * mounts when entering the React subtree, which already implies it's
 * either in the initial viewport or being scrolled to.
 */
export default function BlurFade({
  children,
  className = '',
  delay = 0,
  duration = 0.7,
  offset = 8,
  blur = '8px',
  direction = 'up',
  as: Tag = 'div',
  ...rest
}) {
  const axis = direction === 'left' || direction === 'right' ? 'x' : 'y';
  const sign = direction === 'down' || direction === 'right' ? -offset : offset;
  const initial = { opacity: 0, filter: `blur(${blur})`, [axis]: sign };
  const animate = { opacity: 1, filter: 'blur(0px)', [axis]: 0 };
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      initial={initial}
      animate={animate}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
